import { render, staticRenderFns } from "./TaskFormRelated.vue?vue&type=template&id=6528762a&scoped=true&"
import script from "./TaskFormRelated.vue?vue&type=script&lang=ts&"
export * from "./TaskFormRelated.vue?vue&type=script&lang=ts&"
import style0 from "./TaskFormRelated.vue?vue&type=style&index=0&id=6528762a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6528762a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VForm,VImg})
